import { AwsConfig } from '../Constants';
import BaseService, { RequestInterface } from '../Base';

class GoogleAuth extends BaseService {

	constructor() {
		super(AwsConfig.API_CONFIG, 'graphql');
	}

    async doAuth() {
        const graphQlBody = {
          "query": `{ getGoogleToken { access_token, expires_in, token_type } }`
        }
    
        const params: RequestInterface = {
          body: graphQlBody
        }
    
        const res = await super.post('', params)
        return res
      }
}

export default GoogleAuth